export const GET_ALL_UDIS_ERROR = 'GET_ALL_UDIS_ERROR'
export const GET_ALL_UDIS_REQUEST = 'GET_ALL_UDIS_REQUEST'
export const GET_ALL_UDIS_SUCCESS = 'GET_ALL_UDIS_SUCCESS'
